import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.dashboard');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.dashboard/view.scss */
/* src/app/component.dashboard/view.scss: no such file or directory */`],
})
export class ComponentDashboardComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentDashboardComponent;